/**
 * My API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import {
  HttpClient,
  HttpHeaders,
  HttpParams,
  HttpResponse,
  HttpEvent,
  HttpParameterCodec,
  HttpContext
} from '@angular/common/http';
import { Observable } from 'rxjs';

import { SharedPageModelOfSuccessionManagementTalentEmployeeReviewsTalentReviewEmployeeModel } from '@coin/shared/core/util-models';
import { SharedPageModelOfSuccessionManagementTalentEmployeesTalentEmployeeModel } from '@coin/shared/core/util-models';
import { SharedPageModelOfSuccessionManagementTalentPoolsTalentPoolModel } from '@coin/shared/core/util-models';
import { SharedPageModelOfSystemString } from '@coin/shared/core/util-models';
import { SuccessionManagementDashboardTalentReviewDashboardValuesModel } from '@coin/shared/core/util-models';
import { SuccessionManagementTalentPoolsReferenceMetaTypeModel } from '@coin/shared/core/util-models';
import { SuccessionManagementTalentPoolsTalentPoolAvailabilityModel } from '@coin/shared/core/util-models';
import { SuccessionManagementTalentRecommendationRatiosTalentRecommendationRatioModel } from '@coin/shared/core/util-models';
import { SuccessionManagementTalentRecommendationsAcknowledgeTalentRecommendationModel } from '@coin/shared/core/util-models';
import { SuccessionManagementTalentRecommendationsCreateTalentRecommendationModel } from '@coin/shared/core/util-models';
import { SuccessionManagementTalentRecommendationsTalentRecommendationModel } from '@coin/shared/core/util-models';

import { CustomHttpParameterCodec } from '../encoder';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';

export interface SuccessionManagementCustomerServiceAcknowledgeTalentRecommendationsRequestParams {
  id: string;
  approvalId: string;
  successionManagementTalentRecommendationsAcknowledgeTalentRecommendationModel?: SuccessionManagementTalentRecommendationsAcknowledgeTalentRecommendationModel;
}

export interface SuccessionManagementCustomerServiceCreateTalentRecommendationsRequestParams {
  successionManagementTalentRecommendationsCreateTalentRecommendationModel?: SuccessionManagementTalentRecommendationsCreateTalentRecommendationModel;
}

export interface SuccessionManagementCustomerServiceGetFieldValuesTalentReviewsRequestParams {
  queryAreCode?: string;
  queryTalentPoolTitle?: string;
  queryOrgCode?: string;
  queryOrgName?: string;
  queryPlaceOfAction?: string;
  queryReviewExcluded?: string;
  pagingPage?: number;
  pagingSize?: number;
  sortingOrderBy?: 'Asc' | 'Desc';
  sortingProperty?: string;
  targetProperty?: 0 | 1 | 2 | 3 | 4 | 5 | 6;
}

export interface SuccessionManagementCustomerServiceGetTalentRecommendationRatiosRequestParams {
  orgCode?: string;
}

export interface SuccessionManagementCustomerServiceGetTalentReviewsRequestParams {
  queryTalentPoolTitle?: Array<string>;
  queryReferenceMetaTypes?: Array<string>;
  queryFirstname?: string;
  queryLastname?: string;
  queryGid?: string;
  querySearch?: string;
  queryTalentPoolId?: string;
  queryOrgCode?: string;
  queryOrgName?: string;
  queryPlaceOfAction?: Array<string>;
  queryOrgCodes?: Array<string>;
  queryOrgNames?: Array<string>;
  queryRecommendationState?: Array<'Recommended' | 'ReviewerAccepted' | 'ReviewerDeclined' | 'Approved' | 'Declined'>;
  queryReviewExcluded?: Array<string>;
  queryAreCodes?: Array<string>;
  queryIsWildcardCandidate?: boolean;
  pagingPage?: number;
  pagingSize?: number;
  sortingOrderBy?: 'Asc' | 'Desc';
  sortingProperty?: string;
}

export interface SuccessionManagementCustomerServiceGetTalentsRequestParams {
  queryTalentPoolTitle?: Array<string>;
  queryFirstname?: string;
  queryLastname?: string;
  queryGid?: string;
  querySearch?: string;
  queryTalentPoolId?: string;
  queryOrgCode?: string;
  queryOrgName?: string;
  queryPlaceOfAction?: Array<string>;
  queryOrgCodes?: Array<string>;
  queryOrgNames?: Array<string>;
  queryAreCodes?: Array<string>;
  queryRecommendationState?: Array<'Recommended' | 'ReviewerAccepted' | 'ReviewerDeclined' | 'Approved' | 'Declined'>;
  pagingPage?: number;
  pagingSize?: number;
  sortingOrderBy?: 'Asc' | 'Desc';
  sortingProperty?: string;
}

export interface SuccessionManagementCustomerServiceQueryFieldValuesTalentRecommendationRatiosRequestParams {
  targetProperty: 0;
  pagingPage?: number;
  pagingSize?: number;
  orgCode?: string;
}

export interface SuccessionManagementCustomerServiceQueryFieldValuesTalentsRequestParams {
  queryTalentPoolTitle?: string;
  queryOrgCode?: string;
  queryAreCode?: string;
  queryOrgName?: string;
  queryPlaceOfAction?: string;
  pagingPage?: number;
  pagingSize?: number;
  sortingOrderBy?: 'Asc' | 'Desc';
  sortingProperty?: string;
  targetProperty?: 0 | 1 | 2 | 3 | 4 | 5;
}

export interface SuccessionManagementCustomerServiceQueryTalentPoolsRequestParams {
  queryTitle?: string;
  queryReferenceMetaTypes?: Array<string>;
  pagingPage?: number;
  pagingSize?: number;
  sortingOrderBy?: 'Asc' | 'Desc';
  sortingProperty?: string;
}

export interface SuccessionManagementCustomerServiceRevertTalentRecommendationsRequestParams {
  id: string;
  approvalId: string;
}

@Injectable({
  providedIn: 'root'
})
export class SuccessionManagementCustomerService {
  protected basePath = 'http://localhost';
  public defaultHeaders = new HttpHeaders();
  public configuration = new Configuration();
  public encoder: HttpParameterCodec;

  constructor(
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string | string[],
    @Optional() configuration: Configuration
  ) {
    if (configuration) {
      this.configuration = configuration;
    }
    if (typeof this.configuration.basePath !== 'string') {
      const firstBasePath = Array.isArray(basePath) ? basePath[0] : undefined;
      if (firstBasePath != undefined) {
        basePath = firstBasePath;
      }

      if (typeof basePath !== 'string') {
        basePath = this.basePath;
      }
      this.configuration.basePath = basePath;
    }
    this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
  }

  // @ts-ignore
  private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
    if (typeof value === 'object' && value instanceof Date === false) {
      httpParams = this.addToHttpParamsRecursive(httpParams, value);
    } else {
      httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
    }
    return httpParams;
  }

  private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
    if (value == null) {
      return httpParams;
    }

    if (typeof value === 'object') {
      if (Array.isArray(value)) {
        (value as any[]).forEach(elem => (httpParams = this.addToHttpParamsRecursive(httpParams, elem, key)));
      } else if (value instanceof Date) {
        if (key != null) {
          httpParams = httpParams.append(key, (value as Date).toISOString().substring(0, 10));
        } else {
          throw Error('key may not be null if value is Date');
        }
      } else {
        Object.keys(value).forEach(
          k => (httpParams = this.addToHttpParamsRecursive(httpParams, value[k], key != null ? `${key}.${k}` : k))
        );
      }
    } else if (key != null) {
      httpParams = httpParams.append(key, value);
    } else {
      throw Error('key may not be null if value is not object or array');
    }
    return httpParams;
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public acknowledgeTalentRecommendations(
    requestParameters?: SuccessionManagementCustomerServiceAcknowledgeTalentRecommendationsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SuccessionManagementTalentRecommendationsTalentRecommendationModel>;
  public acknowledgeTalentRecommendations(
    requestParameters?: SuccessionManagementCustomerServiceAcknowledgeTalentRecommendationsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SuccessionManagementTalentRecommendationsTalentRecommendationModel>>;
  public acknowledgeTalentRecommendations(
    requestParameters?: SuccessionManagementCustomerServiceAcknowledgeTalentRecommendationsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SuccessionManagementTalentRecommendationsTalentRecommendationModel>>;
  public acknowledgeTalentRecommendations(
    requestParameters?: SuccessionManagementCustomerServiceAcknowledgeTalentRecommendationsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling acknowledgeTalentRecommendations.');
    }
    const approvalId = requestParameters?.approvalId;
    if (approvalId === null || approvalId === undefined) {
      throw new Error(
        'Required parameter approvalId was null or undefined when calling acknowledgeTalentRecommendations.'
      );
    }
    const successionManagementTalentRecommendationsAcknowledgeTalentRecommendationModel =
      requestParameters?.successionManagementTalentRecommendationsAcknowledgeTalentRecommendationModel;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/succession-management/customer/v1/talent-recommendations/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/approvals/${this.configuration.encodeParam({ name: 'approvalId', value: approvalId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<SuccessionManagementTalentRecommendationsTalentRecommendationModel>(
      'patch',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: successionManagementTalentRecommendationsAcknowledgeTalentRecommendationModel,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createTalentRecommendations(
    requestParameters?: SuccessionManagementCustomerServiceCreateTalentRecommendationsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SuccessionManagementTalentRecommendationsTalentRecommendationModel>;
  public createTalentRecommendations(
    requestParameters?: SuccessionManagementCustomerServiceCreateTalentRecommendationsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SuccessionManagementTalentRecommendationsTalentRecommendationModel>>;
  public createTalentRecommendations(
    requestParameters?: SuccessionManagementCustomerServiceCreateTalentRecommendationsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SuccessionManagementTalentRecommendationsTalentRecommendationModel>>;
  public createTalentRecommendations(
    requestParameters?: SuccessionManagementCustomerServiceCreateTalentRecommendationsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const successionManagementTalentRecommendationsCreateTalentRecommendationModel =
      requestParameters?.successionManagementTalentRecommendationsCreateTalentRecommendationModel;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/succession-management/customer/v1/talent-recommendations`;
    return this.httpClient.request<SuccessionManagementTalentRecommendationsTalentRecommendationModel>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: successionManagementTalentRecommendationsCreateTalentRecommendationModel,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getAvailabilityTalentPools(
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SuccessionManagementTalentPoolsTalentPoolAvailabilityModel>;
  public getAvailabilityTalentPools(
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SuccessionManagementTalentPoolsTalentPoolAvailabilityModel>>;
  public getAvailabilityTalentPools(
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SuccessionManagementTalentPoolsTalentPoolAvailabilityModel>>;
  public getAvailabilityTalentPools(
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/succession-management/customer/v1/talent-pools/availability`;
    return this.httpClient.request<SuccessionManagementTalentPoolsTalentPoolAvailabilityModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getDashboardValuesTalentReviews(
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SuccessionManagementDashboardTalentReviewDashboardValuesModel>;
  public getDashboardValuesTalentReviews(
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SuccessionManagementDashboardTalentReviewDashboardValuesModel>>;
  public getDashboardValuesTalentReviews(
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SuccessionManagementDashboardTalentReviewDashboardValuesModel>>;
  public getDashboardValuesTalentReviews(
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/succession-management/customer/v1/review-talents/dashboard`;
    return this.httpClient.request<SuccessionManagementDashboardTalentReviewDashboardValuesModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getFieldValuesTalentReviews(
    requestParameters?: SuccessionManagementCustomerServiceGetFieldValuesTalentReviewsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedPageModelOfSystemString>;
  public getFieldValuesTalentReviews(
    requestParameters?: SuccessionManagementCustomerServiceGetFieldValuesTalentReviewsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SharedPageModelOfSystemString>>;
  public getFieldValuesTalentReviews(
    requestParameters?: SuccessionManagementCustomerServiceGetFieldValuesTalentReviewsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SharedPageModelOfSystemString>>;
  public getFieldValuesTalentReviews(
    requestParameters?: SuccessionManagementCustomerServiceGetFieldValuesTalentReviewsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const queryAreCode = requestParameters?.queryAreCode;
    const queryTalentPoolTitle = requestParameters?.queryTalentPoolTitle;
    const queryOrgCode = requestParameters?.queryOrgCode;
    const queryOrgName = requestParameters?.queryOrgName;
    const queryPlaceOfAction = requestParameters?.queryPlaceOfAction;
    const queryReviewExcluded = requestParameters?.queryReviewExcluded;
    const pagingPage = requestParameters?.pagingPage;
    const pagingSize = requestParameters?.pagingSize;
    const sortingOrderBy = requestParameters?.sortingOrderBy;
    const sortingProperty = requestParameters?.sortingProperty;
    const targetProperty = requestParameters?.targetProperty;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (queryAreCode !== undefined && queryAreCode !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryAreCode, 'Query.AreCode');
    }
    if (queryTalentPoolTitle !== undefined && queryTalentPoolTitle !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryTalentPoolTitle,
        'Query.TalentPoolTitle'
      );
    }
    if (queryOrgCode !== undefined && queryOrgCode !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryOrgCode, 'Query.OrgCode');
    }
    if (queryOrgName !== undefined && queryOrgName !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryOrgName, 'Query.OrgName');
    }
    if (queryPlaceOfAction !== undefined && queryPlaceOfAction !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryPlaceOfAction,
        'Query.PlaceOfAction'
      );
    }
    if (queryReviewExcluded !== undefined && queryReviewExcluded !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryReviewExcluded,
        'Query.ReviewExcluded'
      );
    }
    if (pagingPage !== undefined && pagingPage !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>pagingPage, 'Paging.Page');
    }
    if (pagingSize !== undefined && pagingSize !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>pagingSize, 'Paging.Size');
    }
    if (sortingOrderBy !== undefined && sortingOrderBy !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>sortingOrderBy, 'Sorting.OrderBy');
    }
    if (sortingProperty !== undefined && sortingProperty !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>sortingProperty, 'Sorting.Property');
    }
    if (targetProperty !== undefined && targetProperty !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>targetProperty, 'TargetProperty');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/succession-management/customer/v1/review-talents/field-values`;
    return this.httpClient.request<SharedPageModelOfSystemString>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getTalentRecommendationRatios(
    requestParameters?: SuccessionManagementCustomerServiceGetTalentRecommendationRatiosRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SuccessionManagementTalentRecommendationRatiosTalentRecommendationRatioModel>;
  public getTalentRecommendationRatios(
    requestParameters?: SuccessionManagementCustomerServiceGetTalentRecommendationRatiosRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SuccessionManagementTalentRecommendationRatiosTalentRecommendationRatioModel>>;
  public getTalentRecommendationRatios(
    requestParameters?: SuccessionManagementCustomerServiceGetTalentRecommendationRatiosRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SuccessionManagementTalentRecommendationRatiosTalentRecommendationRatioModel>>;
  public getTalentRecommendationRatios(
    requestParameters?: SuccessionManagementCustomerServiceGetTalentRecommendationRatiosRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const orgCode = requestParameters?.orgCode;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (orgCode !== undefined && orgCode !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>orgCode, 'OrgCode');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/succession-management/customer/v1/talent-recommendation-ratio`;
    return this.httpClient.request<SuccessionManagementTalentRecommendationRatiosTalentRecommendationRatioModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getTalentReviews(
    requestParameters?: SuccessionManagementCustomerServiceGetTalentReviewsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedPageModelOfSuccessionManagementTalentEmployeeReviewsTalentReviewEmployeeModel>;
  public getTalentReviews(
    requestParameters?: SuccessionManagementCustomerServiceGetTalentReviewsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SharedPageModelOfSuccessionManagementTalentEmployeeReviewsTalentReviewEmployeeModel>>;
  public getTalentReviews(
    requestParameters?: SuccessionManagementCustomerServiceGetTalentReviewsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SharedPageModelOfSuccessionManagementTalentEmployeeReviewsTalentReviewEmployeeModel>>;
  public getTalentReviews(
    requestParameters?: SuccessionManagementCustomerServiceGetTalentReviewsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const queryTalentPoolTitle = requestParameters?.queryTalentPoolTitle;
    const queryReferenceMetaTypes = requestParameters?.queryReferenceMetaTypes;
    const queryFirstname = requestParameters?.queryFirstname;
    const queryLastname = requestParameters?.queryLastname;
    const queryGid = requestParameters?.queryGid;
    const querySearch = requestParameters?.querySearch;
    const queryTalentPoolId = requestParameters?.queryTalentPoolId;
    const queryOrgCode = requestParameters?.queryOrgCode;
    const queryOrgName = requestParameters?.queryOrgName;
    const queryPlaceOfAction = requestParameters?.queryPlaceOfAction;
    const queryOrgCodes = requestParameters?.queryOrgCodes;
    const queryOrgNames = requestParameters?.queryOrgNames;
    const queryRecommendationState = requestParameters?.queryRecommendationState;
    const queryReviewExcluded = requestParameters?.queryReviewExcluded;
    const queryAreCodes = requestParameters?.queryAreCodes;
    const queryIsWildcardCandidate = requestParameters?.queryIsWildcardCandidate;
    const pagingPage = requestParameters?.pagingPage;
    const pagingSize = requestParameters?.pagingSize;
    const sortingOrderBy = requestParameters?.sortingOrderBy;
    const sortingProperty = requestParameters?.sortingProperty;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (queryTalentPoolTitle) {
      queryTalentPoolTitle.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.TalentPoolTitle');
      });
    }
    if (queryReferenceMetaTypes) {
      queryReferenceMetaTypes.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'Query.ReferenceMetaTypes'
        );
      });
    }
    if (queryFirstname !== undefined && queryFirstname !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryFirstname, 'Query.Firstname');
    }
    if (queryLastname !== undefined && queryLastname !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryLastname, 'Query.Lastname');
    }
    if (queryGid !== undefined && queryGid !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryGid, 'Query.Gid');
    }
    if (querySearch !== undefined && querySearch !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>querySearch, 'Query.Search');
    }
    if (queryTalentPoolId !== undefined && queryTalentPoolId !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryTalentPoolId,
        'Query.TalentPoolId'
      );
    }
    if (queryOrgCode !== undefined && queryOrgCode !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryOrgCode, 'Query.OrgCode');
    }
    if (queryOrgName !== undefined && queryOrgName !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryOrgName, 'Query.OrgName');
    }
    if (queryPlaceOfAction) {
      queryPlaceOfAction.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.PlaceOfAction');
      });
    }
    if (queryOrgCodes) {
      queryOrgCodes.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.OrgCodes');
      });
    }
    if (queryOrgNames) {
      queryOrgNames.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.OrgNames');
      });
    }
    if (queryRecommendationState) {
      queryRecommendationState.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'Query.RecommendationState'
        );
      });
    }
    if (queryReviewExcluded) {
      queryReviewExcluded.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.ReviewExcluded');
      });
    }
    if (queryAreCodes) {
      queryAreCodes.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.AreCodes');
      });
    }
    if (queryIsWildcardCandidate !== undefined && queryIsWildcardCandidate !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryIsWildcardCandidate,
        'Query.IsWildcardCandidate'
      );
    }
    if (pagingPage !== undefined && pagingPage !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>pagingPage, 'Paging.Page');
    }
    if (pagingSize !== undefined && pagingSize !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>pagingSize, 'Paging.Size');
    }
    if (sortingOrderBy !== undefined && sortingOrderBy !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>sortingOrderBy, 'Sorting.OrderBy');
    }
    if (sortingProperty !== undefined && sortingProperty !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>sortingProperty, 'Sorting.Property');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/succession-management/customer/v1/review-talents`;
    return this.httpClient.request<SharedPageModelOfSuccessionManagementTalentEmployeeReviewsTalentReviewEmployeeModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getTalents(
    requestParameters?: SuccessionManagementCustomerServiceGetTalentsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedPageModelOfSuccessionManagementTalentEmployeesTalentEmployeeModel>;
  public getTalents(
    requestParameters?: SuccessionManagementCustomerServiceGetTalentsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SharedPageModelOfSuccessionManagementTalentEmployeesTalentEmployeeModel>>;
  public getTalents(
    requestParameters?: SuccessionManagementCustomerServiceGetTalentsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SharedPageModelOfSuccessionManagementTalentEmployeesTalentEmployeeModel>>;
  public getTalents(
    requestParameters?: SuccessionManagementCustomerServiceGetTalentsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const queryTalentPoolTitle = requestParameters?.queryTalentPoolTitle;
    const queryFirstname = requestParameters?.queryFirstname;
    const queryLastname = requestParameters?.queryLastname;
    const queryGid = requestParameters?.queryGid;
    const querySearch = requestParameters?.querySearch;
    const queryTalentPoolId = requestParameters?.queryTalentPoolId;
    const queryOrgCode = requestParameters?.queryOrgCode;
    const queryOrgName = requestParameters?.queryOrgName;
    const queryPlaceOfAction = requestParameters?.queryPlaceOfAction;
    const queryOrgCodes = requestParameters?.queryOrgCodes;
    const queryOrgNames = requestParameters?.queryOrgNames;
    const queryAreCodes = requestParameters?.queryAreCodes;
    const queryRecommendationState = requestParameters?.queryRecommendationState;
    const pagingPage = requestParameters?.pagingPage;
    const pagingSize = requestParameters?.pagingSize;
    const sortingOrderBy = requestParameters?.sortingOrderBy;
    const sortingProperty = requestParameters?.sortingProperty;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (queryTalentPoolTitle) {
      queryTalentPoolTitle.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.TalentPoolTitle');
      });
    }
    if (queryFirstname !== undefined && queryFirstname !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryFirstname, 'Query.Firstname');
    }
    if (queryLastname !== undefined && queryLastname !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryLastname, 'Query.Lastname');
    }
    if (queryGid !== undefined && queryGid !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryGid, 'Query.Gid');
    }
    if (querySearch !== undefined && querySearch !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>querySearch, 'Query.Search');
    }
    if (queryTalentPoolId !== undefined && queryTalentPoolId !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryTalentPoolId,
        'Query.TalentPoolId'
      );
    }
    if (queryOrgCode !== undefined && queryOrgCode !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryOrgCode, 'Query.OrgCode');
    }
    if (queryOrgName !== undefined && queryOrgName !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryOrgName, 'Query.OrgName');
    }
    if (queryPlaceOfAction) {
      queryPlaceOfAction.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.PlaceOfAction');
      });
    }
    if (queryOrgCodes) {
      queryOrgCodes.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.OrgCodes');
      });
    }
    if (queryOrgNames) {
      queryOrgNames.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.OrgNames');
      });
    }
    if (queryAreCodes) {
      queryAreCodes.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.AreCodes');
      });
    }
    if (queryRecommendationState) {
      queryRecommendationState.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'Query.RecommendationState'
        );
      });
    }
    if (pagingPage !== undefined && pagingPage !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>pagingPage, 'Paging.Page');
    }
    if (pagingSize !== undefined && pagingSize !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>pagingSize, 'Paging.Size');
    }
    if (sortingOrderBy !== undefined && sortingOrderBy !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>sortingOrderBy, 'Sorting.OrderBy');
    }
    if (sortingProperty !== undefined && sortingProperty !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>sortingProperty, 'Sorting.Property');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/succession-management/customer/v1/talents`;
    return this.httpClient.request<SharedPageModelOfSuccessionManagementTalentEmployeesTalentEmployeeModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryFieldValuesTalentRecommendationRatios(
    requestParameters?: SuccessionManagementCustomerServiceQueryFieldValuesTalentRecommendationRatiosRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedPageModelOfSystemString>;
  public queryFieldValuesTalentRecommendationRatios(
    requestParameters?: SuccessionManagementCustomerServiceQueryFieldValuesTalentRecommendationRatiosRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SharedPageModelOfSystemString>>;
  public queryFieldValuesTalentRecommendationRatios(
    requestParameters?: SuccessionManagementCustomerServiceQueryFieldValuesTalentRecommendationRatiosRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SharedPageModelOfSystemString>>;
  public queryFieldValuesTalentRecommendationRatios(
    requestParameters?: SuccessionManagementCustomerServiceQueryFieldValuesTalentRecommendationRatiosRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const targetProperty = requestParameters?.targetProperty;
    if (targetProperty === null || targetProperty === undefined) {
      throw new Error(
        'Required parameter targetProperty was null or undefined when calling queryFieldValuesTalentRecommendationRatios.'
      );
    }
    const pagingPage = requestParameters?.pagingPage;
    const pagingSize = requestParameters?.pagingSize;
    const orgCode = requestParameters?.orgCode;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (pagingPage !== undefined && pagingPage !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>pagingPage, 'Paging.Page');
    }
    if (pagingSize !== undefined && pagingSize !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>pagingSize, 'Paging.Size');
    }
    if (targetProperty !== undefined && targetProperty !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>targetProperty, 'TargetProperty');
    }
    if (orgCode !== undefined && orgCode !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>orgCode, 'OrgCode');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/succession-management/customer/v1/talent-recommendation-ratio/field-values`;
    return this.httpClient.request<SharedPageModelOfSystemString>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryFieldValuesTalents(
    requestParameters?: SuccessionManagementCustomerServiceQueryFieldValuesTalentsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedPageModelOfSystemString>;
  public queryFieldValuesTalents(
    requestParameters?: SuccessionManagementCustomerServiceQueryFieldValuesTalentsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SharedPageModelOfSystemString>>;
  public queryFieldValuesTalents(
    requestParameters?: SuccessionManagementCustomerServiceQueryFieldValuesTalentsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SharedPageModelOfSystemString>>;
  public queryFieldValuesTalents(
    requestParameters?: SuccessionManagementCustomerServiceQueryFieldValuesTalentsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const queryTalentPoolTitle = requestParameters?.queryTalentPoolTitle;
    const queryOrgCode = requestParameters?.queryOrgCode;
    const queryAreCode = requestParameters?.queryAreCode;
    const queryOrgName = requestParameters?.queryOrgName;
    const queryPlaceOfAction = requestParameters?.queryPlaceOfAction;
    const pagingPage = requestParameters?.pagingPage;
    const pagingSize = requestParameters?.pagingSize;
    const sortingOrderBy = requestParameters?.sortingOrderBy;
    const sortingProperty = requestParameters?.sortingProperty;
    const targetProperty = requestParameters?.targetProperty;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (queryTalentPoolTitle !== undefined && queryTalentPoolTitle !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryTalentPoolTitle,
        'Query.TalentPoolTitle'
      );
    }
    if (queryOrgCode !== undefined && queryOrgCode !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryOrgCode, 'Query.OrgCode');
    }
    if (queryAreCode !== undefined && queryAreCode !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryAreCode, 'Query.AreCode');
    }
    if (queryOrgName !== undefined && queryOrgName !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryOrgName, 'Query.OrgName');
    }
    if (queryPlaceOfAction !== undefined && queryPlaceOfAction !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryPlaceOfAction,
        'Query.PlaceOfAction'
      );
    }
    if (pagingPage !== undefined && pagingPage !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>pagingPage, 'Paging.Page');
    }
    if (pagingSize !== undefined && pagingSize !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>pagingSize, 'Paging.Size');
    }
    if (sortingOrderBy !== undefined && sortingOrderBy !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>sortingOrderBy, 'Sorting.OrderBy');
    }
    if (sortingProperty !== undefined && sortingProperty !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>sortingProperty, 'Sorting.Property');
    }
    if (targetProperty !== undefined && targetProperty !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>targetProperty, 'TargetProperty');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/succession-management/customer/v1/talents/field-values`;
    return this.httpClient.request<SharedPageModelOfSystemString>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryReferenceMetaTypesTalentPools(
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<Array<SuccessionManagementTalentPoolsReferenceMetaTypeModel>>;
  public queryReferenceMetaTypesTalentPools(
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<Array<SuccessionManagementTalentPoolsReferenceMetaTypeModel>>>;
  public queryReferenceMetaTypesTalentPools(
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<Array<SuccessionManagementTalentPoolsReferenceMetaTypeModel>>>;
  public queryReferenceMetaTypesTalentPools(
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/succession-management/customer/v1/talent-pools/reference-meta-types`;
    return this.httpClient.request<Array<SuccessionManagementTalentPoolsReferenceMetaTypeModel>>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryTalentPools(
    requestParameters?: SuccessionManagementCustomerServiceQueryTalentPoolsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedPageModelOfSuccessionManagementTalentPoolsTalentPoolModel>;
  public queryTalentPools(
    requestParameters?: SuccessionManagementCustomerServiceQueryTalentPoolsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SharedPageModelOfSuccessionManagementTalentPoolsTalentPoolModel>>;
  public queryTalentPools(
    requestParameters?: SuccessionManagementCustomerServiceQueryTalentPoolsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SharedPageModelOfSuccessionManagementTalentPoolsTalentPoolModel>>;
  public queryTalentPools(
    requestParameters?: SuccessionManagementCustomerServiceQueryTalentPoolsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const queryTitle = requestParameters?.queryTitle;
    const queryReferenceMetaTypes = requestParameters?.queryReferenceMetaTypes;
    const pagingPage = requestParameters?.pagingPage;
    const pagingSize = requestParameters?.pagingSize;
    const sortingOrderBy = requestParameters?.sortingOrderBy;
    const sortingProperty = requestParameters?.sortingProperty;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (queryTitle !== undefined && queryTitle !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryTitle, 'Query.Title');
    }
    if (queryReferenceMetaTypes) {
      queryReferenceMetaTypes.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'Query.ReferenceMetaTypes'
        );
      });
    }
    if (pagingPage !== undefined && pagingPage !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>pagingPage, 'Paging.Page');
    }
    if (pagingSize !== undefined && pagingSize !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>pagingSize, 'Paging.Size');
    }
    if (sortingOrderBy !== undefined && sortingOrderBy !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>sortingOrderBy, 'Sorting.OrderBy');
    }
    if (sortingProperty !== undefined && sortingProperty !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>sortingProperty, 'Sorting.Property');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/succession-management/customer/v1/talent-pools`;
    return this.httpClient.request<SharedPageModelOfSuccessionManagementTalentPoolsTalentPoolModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public revertTalentRecommendations(
    requestParameters?: SuccessionManagementCustomerServiceRevertTalentRecommendationsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SuccessionManagementTalentRecommendationsTalentRecommendationModel>;
  public revertTalentRecommendations(
    requestParameters?: SuccessionManagementCustomerServiceRevertTalentRecommendationsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SuccessionManagementTalentRecommendationsTalentRecommendationModel>>;
  public revertTalentRecommendations(
    requestParameters?: SuccessionManagementCustomerServiceRevertTalentRecommendationsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SuccessionManagementTalentRecommendationsTalentRecommendationModel>>;
  public revertTalentRecommendations(
    requestParameters?: SuccessionManagementCustomerServiceRevertTalentRecommendationsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling revertTalentRecommendations.');
    }
    const approvalId = requestParameters?.approvalId;
    if (approvalId === null || approvalId === undefined) {
      throw new Error('Required parameter approvalId was null or undefined when calling revertTalentRecommendations.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/succession-management/customer/v1/talent-recommendations/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/approvals/${this.configuration.encodeParam({ name: 'approvalId', value: approvalId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<SuccessionManagementTalentRecommendationsTalentRecommendationModel>(
      'delete',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }
}
